import { frontendURL } from '../../../helper/URLHelper';
import { laisCanonicalRedirect } from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/brand-voice'),
    alias: [
      frontendURL('accounts/:accountId/brandvoice'),
      frontendURL('accounts/:accountId/voz-da-marca'),
    ],
    name: 'brand_voice_editor',
    redirect: laisCanonicalRedirect('minha_lais_index', {
      query: { tab: 'brand_voice' },
    }),
    meta: { permissions: ['administrator'] },
  },
];
